const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    viewBox: "0 0 744.09 1052.4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3053",
    style: {
      opacity: 0.4906,
      fill: "#6f8a91"
    },
    d: "m737.14 1192.4a414.29 102.86 0 1 1 -828.57 0 414.29 102.86 0 1 1 828.57 0z",
    transform: "matrix(.42076 0 0 .33728 237.52 576.38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3014",
    style: {
      fill: "rgb(212, 212, 212)"
    },
    d: "m373.3 58.058c-183.43 0.258-332.05 149.04-332.05 332.53 0 121.52 65.173 227.8 162.48 285.82 94.942 70.715 159.22 180.26 169.37 305.13l0.19675 0.33729 0.0843-0.14058 0.0562 0.14058 0.19675-0.33729c10.16-124.88 74.43-234.42 169.38-305.13 97.312-58.012 162.48-164.3 162.48-285.82 0-183.49-148.62-332.27-332.05-332.53-0.0469-0.000063-0.0937 0.000045-0.14053 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3051",
    style: {
      fill: "rgb(85, 85, 85)"
    },
    d: "M 634.618 389.293 C 634.618 590.399 416.914 716.09 242.751 615.537 C 161.921 568.87 112.128 482.626 112.128 389.293 C 112.128 188.186 329.832 62.495 503.995 163.048 C 584.825 209.715 634.618 295.959 634.618 389.293 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3055",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    d: "M 629.552 380.061 C 629.552 574.065 416.048 695.318 245.245 598.316 C 165.975 553.297 117.142 470.099 117.142 380.061 C 117.142 186.056 330.646 64.803 501.45 161.806 C 580.72 206.825 629.552 290.023 629.552 380.061 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 342.497 225.809 H 404.198 V 349.21 H 527.599 V 410.911 H 404.198 V 534.312 H 342.497 V 410.911 H 219.096 V 349.21 H 342.497 Z",
    style: {
      fill: "rgb(209, 209, 209)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPin);
export default __webpack_public_path__ + "static/media/add-pin.b03b4d0cbc95cf40c90ce9810f705a6e.svg";
export { ForwardRef as ReactComponent };